module.exports = __webpack_public_path__ + "static/media/Quantum-Gradient.53b0cdc9.svg";